<template>
  <div class="obs_welcome">
    <div class="obs_welcom_animation">
      <div class="obs_welcom_animation-frame">
        <svg id="frame_background" :class="{ '--show': showBgFrame }" class="start_animate" width="304" height="201" viewBox="0 0 304 201" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path opacity="0.2" d="M0.5 14.001C0.5 6.26899 6.76801 0.000976562 14.5 0.000976562H289.5C297.232 0.000976562 303.5 6.26899 303.5 14.001V187.001C303.5 194.733 297.232 201.001 289.5 201.001H14.5C6.76802 201.001 0.5 194.733 0.5 187.001V14.001Z" fill="#7190FF" />
          <circle cx="98.8301" cy="31.1601" r="5" transform="rotate(75.8865 98.8301 31.1601)" fill="white" />
          <circle cx="136.044" cy="30.3775" r="6" transform="rotate(75.8865 136.044 30.3775)" fill="white" />
          <circle cx="95.8648" cy="65.1937" r="7.5" transform="rotate(75.8865 95.8648 65.1937)" fill="white" />
        </svg>
        <svg id="frame_border" :class="{ '--show': showBdFrame }" class="start_animate" width="303" height="201" viewBox="0 0 303 201" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect opacity="0.5" x="3" y="3.00098" width="297" height="195" rx="15" stroke="#0A3BE7" stroke-width="6" />
        </svg>

        <svg id="gempage_logo" :class="{ '--show': showLogo }" class="start_animate" width="98" height="105" viewBox="0 0 98 105" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g opacity="0.5">
            <path d="M96.3692 0.0349149L0.51989 29.5916C0.132691 29.6959 -0.0785088 30.1132 0.0270909 30.5305L7.41907 54.4888C7.52467 54.8713 7.94707 55.1147 8.33427 54.9756L78.6637 33.2775C82.0077 32.2343 84.8589 29.9393 86.4781 26.8098C90.8428 18.5339 94.4684 9.91033 97.2492 0.973775C97.4604 0.382641 96.9324 -0.138948 96.3692 0.0349149Z" fill="#0A3BE7" />
            <path d="M73.3841 41.4786L13.8258 59.8385C13.509 59.9428 13.2978 60.2906 13.4034 60.6383L19.669 80.8759C19.7746 81.1889 20.1266 81.3975 20.4434 81.2932L58.4241 69.5748C61.2753 68.7055 63.6337 66.7235 65.0417 64.1155C68.7377 57.1263 71.8001 49.824 74.1233 42.2784C74.2993 41.7916 73.8417 41.3395 73.3841 41.4786Z" fill="#0A3BE7" />
            <path d="M47.4518 79.5122L25.9095 86.1538C25.6279 86.2233 25.4871 86.5363 25.5575 86.8144L30.8375 103.923C30.9079 104.201 31.2247 104.375 31.5063 104.27L34.8151 103.262C37.2087 102.532 39.2151 100.863 40.4119 98.6371C43.5446 92.7258 46.1142 86.571 48.0854 80.1729C48.2614 79.7556 47.8742 79.3731 47.4518 79.5122Z" fill="#0A3BE7" />
          </g>
        </svg>

        <svg id="confetti_top_right" :class="{ '--show': showConfetti, '--flash-shine': showConfettiFlash }" class="start_animate" width="50" height="43" viewBox="0 0 50 43" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path opacity="0.5" fill-rule="evenodd" clip-rule="evenodd" d="M27.9893 28.6534L41.3091 26.8964L42.0938 32.8448L28.774 34.6019L27.9893 28.6534Z" fill="#FFBB1C" />
          <path opacity="0.5" fill-rule="evenodd" clip-rule="evenodd" d="M17.4376 18.3951L18.8198 5.0313L12.8517 4.41401L11.4694 17.7778L17.4376 18.3951Z" fill="#FFBB1C" />
          <path opacity="0.5" fill-rule="evenodd" clip-rule="evenodd" d="M33.0083 9.03165L21.4014 20.9692L25.7032 25.1518L37.3101 13.2143L33.0083 9.03165Z" fill="#FFBB1C" />
        </svg>

        <svg id="confetti_bottom_right" :class="{ '--show': showConfetti, '--flash-shine': showConfettiFlash }" class="start_animate" width="26" height="32" viewBox="0 0 26 32" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path opacity="0.5" d="M21.8046 18.7626L19.8985 27.7416L11.1693 30.5803L4.34635 24.4401L6.2525 15.461L14.9816 12.6223L21.8046 18.7626Z" fill="#06E884" />
          <path fill-rule="evenodd" clip-rule="evenodd" d="M15.4592 2.06434L24.4589 10.0128L22.0752 21.781L10.6918 25.6008L1.69204 17.6524L4.07573 5.88412L15.4592 2.06434ZM8.31522 9.62838L7.05441 15.853L11.8147 20.0572L17.8357 18.0368L19.0965 11.8122L14.3363 7.60798L8.31522 9.62838Z" fill="#7190FF" />
        </svg>

        <svg id="confetti_top_left" :class="{ '--show': showConfetti, '--flash-shine': showConfettiFlash }" class="start_animate" width="48" height="45" viewBox="0 0 48 45" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect opacity="0.5" x="30.1914" y="15.6613" width="20" height="20" rx="4" transform="rotate(90 30.1914 15.6613)" fill="#06E884" />
          <rect opacity="0.5" x="38.1909" y="8.66125" width="20" height="20" rx="4" transform="rotate(90 38.1909 8.66125)" stroke="#0A3BE7" stroke-width="5" stroke-linecap="round" stroke-linejoin="round" />
        </svg>

        <svg id="confetti_bottom_left" :class="{ '--show': showConfetti, '--flash-shine': showConfettiFlash }" class="start_animate" width="35" height="40" viewBox="0 0 35 40" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path opacity="0.5" d="M23.629 19.517L26.6387 28.987L19.9424 36.3286L10.2362 34.2001L7.22643 24.7301L13.9228 17.3885L23.629 19.517Z" fill="#FFBB1C" />
          <path fill-rule="evenodd" clip-rule="evenodd" d="M26.3359 7.58599L30.273 19.9737L21.5135 29.5772L8.81681 26.793L4.87972 14.4052L13.6393 4.80175L26.3359 7.58599ZM15.4939 10.6372L10.8607 15.7168L12.9432 22.2691L19.6588 23.7418L24.292 18.6622L22.2096 12.1099L15.4939 10.6372Z" fill="#7190FF" />
        </svg>
      </div>
    </div>
    <h1 class="obs_welcome--title">
      {{ $t("onboardingStep.welcome.title") }}<b v-if="userName">, </b><span>{{ userName }}</span>
    </h1>
    <h3 class="obs_welcome--subtitle">{{ $t("onboardingStep.welcome.subtitle") }}</h3>
    <button type="button" @click="nextStep" class="obs_btn obs_btn_large">{{ $t("onboardingStep.welcome.button") }}</button>
    <p class="obs_welcome--tos-privacy" v-html="$t('onboardingStep.welcome.tosPrivacyText')"></p>
    <p v-if="skippable" class="obs_welcome-skiped typo-center">
      <span class="typo-lightmode paragraph14">{{ $t("onboardingStep.welcome.skipText") }}</span>
      <a @click="submitForm" class="skip_link">{{ $t("onboardingStep.welcome.skipLinkText") }}</a>
    </p>
  </div>
</template>

<script>
import obsLocalData from "@/utils/obsLocalData.js";
import { mapMutations, mapState } from "vuex";
import { mutations } from "@/store/onboarding/types.js";
export default {
  name: "Welcome",
  props: {
    userName: {
      type: String,
      default: ""
    },
    skippable: {
      type: Boolean,
      default: false
    },
    step: Number
  },
  data() {
    return {
      showBgFrame: false,
      showBdFrame: false,
      showLogo: false,
      showConfetti: false,
      showConfettiFlash: false
    };
  },
  computed: {
    ...mapState("account", {
      shopInfo: state => state.shopInfo
    })
  },
  watch: {
    shopInfo() {
      this.checkUserScope();
    }
  },
  mounted () {
    this.checkUserScope();
  },
  created() {
    setTimeout(() => {
      this.showBgFrame = true;
      this.showBdFrame = true;
      this.showConfetti = true;
    }, 1200);
    setTimeout(() => {
      this.showLogo = true;
    }, 1000);
    setTimeout(() => {
      this.showConfettiFlash = true;
    }, 2200);
    this.resetObsLocalData();
  },
  methods: {
    ...mapMutations("onboarding", {
      obsSubcribe: mutations.OBS_SUBSCRIBE
    }),
    nextStep() {
      this.$emit("next", this.step);
    },
    resetObsLocalData() {
      setTimeout(() => {
        const surveys = this.shopInfo ? this.shopInfo.surveys : [];
        const shopifyDomain = this.shopInfo.shopifyDomain;
        const surveyObs = surveys.filter(sv => sv.name == "onboarding");
        if (surveyObs && surveyObs.length > 0 && surveyObs[0].name != "onboarding") {
          obsLocalData.remove(shopifyDomain);
        }
      }, 1000);
    },
    submitForm() {
      this.$emit("data",true);
    },
    
    /**
     * Send a message to popup opener (eg: editor) to trigger close action
     * after getting a permission from Shopify
     */
    checkUserScope() {
      if(this.shopInfo) {
        const userScopeString = this.shopInfo.userScope;
        const scopes = userScopeString.split(",").map(permission => permission.replace("\n", "").trim());
        if(scopes.includes("write_files")) {
          if(window.opener) {
            window.opener.postMessage("isAuthorized", `${window.location.protocol}//${window.location.host}`);
          }
        }
      }
    },
  }
};
</script>

<style lang="scss" scoped>
.obs_welcome {
  width: 100%;
  height: calc(100% - 96px);
  display: flex;
  justify-content: flex-start;
  padding-top: 67px;
  align-items: center;
  flex-direction: column;
  padding-bottom: 60px;
  .obs_welcom_animation {
    // background-color: #ddd;
    margin-bottom: 20px;
  }
  .obs_welcome--title {
    font-size: 40px;
    font-weight: 700;
    line-height: 60px;
    color: $textLightModeHigh;
    animation-name: text-smooth;
    animation-timing-function: linear;
    animation-duration: 1200ms;
    animation-delay: 0;
    text-transform: capitalize;
    span {
      color: $mono3;
    }
  }
  .obs_welcome--subtitle {
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    margin-bottom: 32px;
    color: $textLightModeLow;
    animation-name: text-smooth;
    animation-timing-function: linear;
    animation-duration: 2000ms;
    animation-delay: 0;
  }
  .obs_welcome-skiped {
    &:hover{
      .skip_link {
        color: $mono4;
        text-decoration: underline;
      }
    }
    font-weight: 500;
    margin-top: 32px;
    color: $textLightModeLow;
    .skip_link {
      cursor: pointer;
      color: $mono3;
      margin-left: 5px;
      transition: text-decoration 200ms;
    }
  }
  .obs_welcom_animation-frame {
    width: 367px;
    height: 254px;
    position: relative;
    #frame_background {
      position: absolute;
      left: 18px;
      bottom: 14px;
      opacity: 0;
      &.start_animate {
        animation-name: conor-left-to-center;
        animation-duration: 1200ms;
        animation-delay: 50ms;
      }
      &.--show {
        opacity: 1;
      }
    }
    #frame_border {
      position: absolute;
      right: 18px;
      top: 14px;
      opacity: 0;
      &.start_animate {
        animation-name: conor-right-to-center;
        animation-duration: 1200ms;
        animation-delay: 50ms;
      }
      &.--show {
        opacity: 1;
      }
    }
    #gempage_logo {
      position: absolute;
      top: 50%;
      left: 50%;
      opacity: 0;
      &.start_animate {
        transform: translate(-50%, -50%);
        animation-name: bottom-to-center;
        animation-duration: 1000ms;
        animation-delay: 800ms;
      }
      &.--show {
        opacity: 1;
      }
    }
    #confetti_top_right {
      position: absolute;
      top: -16px;
      right: -26px;
      opacity: 0;
      &.start_animate {
        animation-name: dark-to-shine;
        animation-duration: 1200ms;
        animation-delay: 600ms;
      }
      &.--show {
        opacity: 1;
      }
      &.--flash-shine {
        path:nth-child(1) {
          animation: flash-shining 0.8s linear infinite;
          animation-delay: 0.15s;
        }
        path:nth-child(2) {
          animation: flash-shining 1s linear infinite;
          animation-delay: 0.15s;
        }
        path:nth-child(3) {
          animation: flash-shining 1.2s linear infinite;
          animation-delay: 0.15s;
        }
      }
    }
    #confetti_bottom_right {
      position: absolute;
      bottom: 52px;
      right: -62px;
      opacity: 0;
      &.start_animate {
        animation-name: centrifugal-bottom-right;
        animation-timing-function: linear;
        animation-duration: 1200ms;
        animation-delay: 800ms;
      }
      &.--show {
        opacity: 1;
      }
      &.--flash-shine {
        opacity: 1;
        animation: flash-shine 1.2s linear infinite;
        animation-delay: 0.15s;
      }
    }
    #confetti_top_left {
      position: absolute;
      top: 0px;
      left: -42px;
      opacity: 0;
      &.start_animate {
        animation-name: centrifugal-top-left;
        animation-timing-function: linear;
        animation-duration: 1200ms;
        animation-delay: 800ms;
      }
      &.--show {
        opacity: 1;
      }
      &.--flash-shine {
        opacity: 1;
        animation: flash-shine 1s linear infinite;
        animation-delay: 0.15s;
      }
    }
    #confetti_bottom_left {
      position: absolute;
      bottom: 60px;
      left: -62px;
      opacity: 0;
      &.start_animate {
        animation-name: centrifugal-bottom-left;
        animation-timing-function: linear;
        animation-duration: 1200ms;
        animation-delay: 800ms;
      }
      &.--show {
        opacity: 1;
      }
      &.--flash-shine {
        opacity: 1;
        animation: flash-shine 1.4s linear infinite;
        animation-delay: 0.15s;
      }
    }
  }
  /deep/ .obs_welcome--tos-privacy {
    margin-top: 8px;
    font-size: 14px;
    color: $textLightModeLow;
    line-height: 21px;
    font-weight: 500;
    text-align: center;
    .tos-privacy-link {
      cursor: pointer;
      color: $mono3;
      transition: text-decoration 200ms;
      &:hover {
        color: $mono4;
        text-decoration: underline;
      }
    }
  }
}
@keyframes conor-left-to-center {
  from {
    left: 0;
    bottom: 0;
    opacity: 0.2;
  }
  to {
    left: 18px;
    bottom: 14px;
    opacity: 1;
  }
}
@keyframes conor-right-to-center {
  from {
    right: 0;
    top: 0;
    opacity: 0.2;
  }
  to {
    right: 18px;
    top: 14px;
    opacity: 1;
  }
}
@keyframes bottom-to-center {
  from {
    top: 100%;
    opacity: 0.1;
  }
  to {
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    opacity: 1;
  }
}
@keyframes dark-to-shine {
  from {
    top: -16px;
    right: -26px;
    opacity: 0.1;
  }
  to {
    top: -16px;
    right: -26px;
    opacity: 1;
  }
}
@keyframes centrifugal-bottom-right {
  0% {
    bottom: 0px;
    right: 62px;
    transform: scale(0.1);
  }
  25% {
    bottom: 13px;
    right: 31px;
    transform: scale(1);
  }
  50% {
    bottom: 26px;
    right: -0px;
    transform: scale(1.4);
  }
  75% {
    bottom: 39px;
    right: -31px;
    transform: scale(1.2);
  }
  100% {
    bottom: 52px;
    right: -62px;
    transform: scale(1);
  }
}
@keyframes centrifugal-top-left {
  0% {
    top: 44px;
    left: -6px;
    transform: scale(0.1);
  }
  25% {
    top: 33px;
    left: -15px;
    transform: scale(1);
  }
  50% {
    top: 22px;
    left: -24px;
    transform: scale(1.4);
  }
  75% {
    top: 11px;
    left: -33px;
    transform: scale(1.2);
  }
  100% {
    top: 0px;
    left: -42px;
    transform: scale(1);
  }
}
@keyframes centrifugal-bottom-left {
  0% {
    bottom: 12px;
    left: -14px;
    transform: scale(0.1);
  }
  25% {
    bottom: 24px;
    left: -26px;
    transform: scale(1);
  }
  50% {
    bottom: 36px;
    left: -38px;
    transform: scale(1.4);
  }
  75% {
    bottom: 48px;
    left: -50px;
    transform: scale(1.2);
  }
  100% {
    bottom: 60px;
    left: -62px;
    transform: scale(1);
  }
}
@keyframes text-smooth {
  from {
    transform: scale(0.9);
    opacity: 0.5;
  }
  to {
    transform: scale(1);
    opacity: 1;
  }
}
@keyframes flash-shine {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(0.65);
  }
}
@keyframes flash-shining {
  0% {
    opacity: 0.4;
  }
  50% {
    opacity: 1;
  }
}
</style>
